'use client';

import { Box } from '@terra/ui-styled-system';

export function DetachedWindowDragBar() {
  return (
    <Box
      h="9"
      borderBottomWidth="1px"
      borderColor="border.subtle"
      pl="20"
      bg="bg.subtle"
      flexShrink={0}
      style={{ WebkitAppRegion: 'drag' } as React.CSSProperties}
    />
  );
}
